export default __webpack_public_path__ + "static/featured-6be06f0ea5a8ad0df40d843f8367f2e8.png";